import { Organization } from '@ngb-frontend/shared/types'

import { countryCodeToOrg, systemCodeToOrg } from '../locale/countryCodeToOrg'

import type {
  AyvensSubsidiaryCode,
  QueryCountryCode,
  SystemCode,
} from '@ngb-frontend/shared/types'

// TODO: Replace calls to this function with CountryContext.is[CountryPrettyName]
export const isLPSystem = (systemCode?: string) => {
  return !!(
    systemCode && systemCodeToOrg[systemCode as SystemCode] === Organization.LP
  )
}

// TODO: Replace calls to this function with CountryContext.is[CountryPrettyName]
export const isAyvensCountry = (
  countryCode?: QueryCountryCode,
): countryCode is AyvensSubsidiaryCode => {
  return !!(
    countryCode && countryCodeToOrg[countryCode] === Organization.AYVENS
  )
}
